// const API = "http://localhost:5237/api"
const API = "https://bookay-backend-m6ihf.ondigitalocean.app/api"

export default API
